import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Renderer2,
  Output,
  EventEmitter,
} from "@angular/core";
import { panierAnim } from "src/app/models/consts/anims";
import { PanierService } from "src/app/services/manage/panier/panier.service";
import { ToolsService } from "src/app/services/tools/tools.service";
import { Product } from "src/app/models/class/product";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MediaObserver } from "@angular/flex-layout";
import { ProdComponent } from "src/app/components/dialogs/prod/prod.component";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";
import { ClientaddressesService } from "src/app/services/apiclient/clientaddresses/clientaddresses.service";
import { FulleStockService } from "src/app/services/api/fulle/fulle-stock/fulle-stock.service";
import { ProductService } from "src/app/services/api/product/product.service";
import {SalemethodService} from "../../../../services/api/salemethod/salemethod.service";

@Component({
  selector: "app-panier",
  templateUrl: "./panier.component.html",
  styleUrls: ["./panier.component.css"],
  animations: [panierAnim],
})
export class PanierComponent implements OnInit {
  @Input() products$: any;
  @Input() categories$: any;
  @Input() activeButton: boolean | any;
  @Input() error: string | any;

  /**
   * Address and relay
   */
  @Input() currDelivryAddress$: any;
  @Input() selectedRelay: any;
  @Input() isRelay: any;

  @Input() sideMode: string | any;

  @Output()
  closeBasketEvent: EventEmitter<any> = new EventEmitter();

  @Output()
  outPutSubmitOrder: EventEmitter<any> = new EventEmitter();

  panier$: Product[] = [];

  default_prod: string =
    "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  currAddress: any;

  totalQuantPan: number | any;
  totalPricePan: number | any;
  totalWeightPan: number | any;
  maxWeightPan: number | any;
  shippingPrice: number | any;
  shippingOffer: number | any;
  needRelay: boolean = false;
  deliveryPrice: number | any;
  deliveryOffer: number | any;
  allTotal: number | any;

  numQuant: number[] = [];
  quantityChanged: any = null;
  constructor(
    private panierMan: PanierService,
    public tools: ToolsService,
    private addressApi: ClientaddressesService,
    private router: Router,
    public dialog: MatDialog,
    public myDials: DialogsService,
    public media: MediaObserver,
    public renderer: Renderer2,
    private stockApi: FulleStockService,
    public ProductService: ProductService
  ) { }

  ngOnInit() {
    this.stockApi.displayAlertStockDialog(null, false).then((data) => {
      this.addressApi.getDelivryAddress.subscribe((address) => {
        this.currAddress = address;
        this.getInfoPan();
        this.getInfoShipping();
      });
      this.panierMan.getPanier.subscribe((basket) => {
        this.panier$ = basket;
        this.getInfoPan();
        this.getInfoShipping();
      });
    });
  }

  ngOnChanges(changes: SimpleChanges | any): void {


    if (
      // changes.currDelivryAddress$ && changes.currDelivryAddress$.currentValue||
      (changes.selectedRelay && changes.selectedRelay.currentValue) ||
      changes.isRelay
    ) {
      this.getInfoPan();
      this.getInfoShipping();
    }

    if (changes.error && changes.error.currentValue) {
      if (
        changes.error.currentValue !== "emptypanier" &&
        this.sideMode === "over"
      ) {
        this.closeBasket();
      }
    }
  }

  openProdDial(prod: any, from: string, index?: number) {



    const myConf = new MatDialogConfig();

    this.media.isActive("xs")
      ? (myConf.panelClass = "full-screen")
      : (myConf.width = prod.product_type === 2 ? "780px" : "450px");

    myConf.autoFocus = false;
    myConf.data = {
      index: index,
      from: from,
      prod: prod,
      products: this.products$,
      categories: this.categories$,
    };

    // this.ProductService.setObserProductTypeformule(prod.product_type == 2?true:false);
    const myDial = this.dialog.open(ProdComponent, myConf);
    myDial.afterClosed().subscribe((result) => { });
  }

  /**
   * @description Change la quantité d'un produit dans le panier
   * @param {number} i
   * @param {any} prod
   * @return {void}
   */
  updateQuantPan(i: number, prod: any): void {
    if (this.quantityChanged) {
      let stock = null;
      if (i >= 0)
        stock = this.update_stock(prod);
      prod.product_type < 2
        ? this.panierMan.manageProduct(prod, stock, i)
        : this.panierMan.manageProductFormule(prod, prod.details, stock, i);
    }
    this.quantityChanged = null;
  }

  /**
   * @description Change la quantité d'un produit et dans le stock
   * @param {any} prod
   */
  update_stock(prod: any) {
    if (prod.stock) {
      prod.stock.count = this.stockApi.handleProdStock(
        prod.id,
        this.quantityChanged,
        "remove",
        prod.stock.newcount
      );
    }

    if (prod.details) {
      prod.details.map((det: any) => {
        if (det.stock) {
          det.stock.count = this.stockApi.handleProdStock(
            det.id,
            this.quantityChanged,
            "remove",
            det.stock.newcount
          );
        }
      });
    }

    return this.stockApi.stocks;
  }

  /**
   * @description Récupère toutes les infos du panier
   * @returns {void}
   */
  getInfoPan(): void {
    this.totalQuantPan = this.panierMan.getQuant();
    this.totalPricePan = this.panierMan.getPrice();
    this.totalWeightPan = this.panierMan.getWeight();
    if (this.isRelay && !this.selectedRelay) {
      this.allTotal = this.totalPricePan;
    } else {
      this.allTotal = this.panierMan.getPanInfos(
        "allship",
        this.isRelay ? this.selectedRelay : null,
        1
      );
    }
  }

  /**
   * @description calcul l'ecart entre ancienne et nouvelle qté stock
   * @param {number} newQty
   * @param {number} oldQty
   */
  QtyStockChange(newQty: number, oldQty: number) {
    this.quantityChanged = newQty - oldQty;
  }

  getInfoShipping() {
    /**
     * Livraison
     */
    this.deliveryPrice = this.panierMan.getPanInfos("delivery");
    this.deliveryOffer = this.panierMan.getPanInfos("deliveryOffer");

    /**
     * Expedition
     */
    this.shippingPrice =

      this.isRelay && this.selectedRelay
        ? this.addressApi.getShippingPrice(this.panier$, this.selectedRelay, 2)
        : this.addressApi.getShippingPrice(this.panier$, null, 3);

    this.shippingOffer =

      this.currDelivryAddress$ && this.currDelivryAddress$.shipping_mode
        ? this.currDelivryAddress$.shipping_mode.offered_from
        : null;

    this.needRelay = this.isRelay && !this.selectedRelay ? true : false;

  }

  /**
   * @description Retire un produit du panier
   * @param {number} index
   * @param {any} prod
   * @return {void}
   */
  removeProdPan(index: number, prod: any): void {
    this.panierMan.removeProduct(index);

    //formule
    // prod.categories && prod.categories.length > 0 &&
    if (prod.categories && prod.categories.length > 0 && prod.product_type == 2) {
      //change le stock

      this.changeStock(prod);
      this.panierMan.setCurrentBasket(prod, "delete");
    } else if (prod.stock) {
      // produit
      this.stockApi.handleProdStock(
        prod.id,
        prod.quantity,
        "add",
        prod.stock.newcount
      );
      this.panierMan.setCurrentBasket(prod, "delete");
    }

    this.getInfoPan();
  }

  /**
   * @description on change le stock lors d'une suppression d'une formule qui à un produit avec du stock
   * @param {any} prod
   * @return {void}
   */
  changeStock(prod: any): void {

    if (prod.details.length > 0)
      for (let i = 0; i < prod.details.length; i++) {
        let item = prod.details[i];
        if (item.stock) {
          this.stockApi.handleProdStock(
            item.id,
            item.quantity * prod.quantity,
            "add",
            item.stock.newcount
          );
        }
      }
  }

  /**
   * @description Redirige vers la page de fin de commande
   * @return {void}
   */
  goEndOrder(): void {

    this.stockApi.displayAlertStockDialog(null, true).then((result) => {

      if (result.data) {
        if (this.totalPricePan < this.currSm.minimum_order) {
          this.myDials.openMiniAmountDial();
        } else {

          this.router.navigate(["/endorder"]);
        }
      }
    });
  }

  submitOrder() {
    this.outPutSubmitOrder.emit(true);
  }

  closeBasket() {
    this.closeBasketEvent.emit();
  }
}
